/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type AvailabilityCalendarContainer_viewer$ref = any;
type LibraryContainer_viewer$ref = any;
type ScheduleContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type InvoiceContainer_viewer$ref: FragmentReference;
export type InvoiceContainer_viewer = {|
  +id: string,
  +first_name: ?string,
  +last_name: ?string,
  +s_time_zone: ?string,
  +payment_methods: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +__typename: "SquarePaymentMethod",
        +id?: string,
        +enabled?: ?boolean,
        +application_id?: ?string,
        +location_id?: ?string,
        +instructions?: ?string,
        +address?: ?string,
        +pay_to?: ?string,
        +label?: ?string,
      |}
    |}>
  |},
  +primary_brand: ?{|
    +id: string
  |},
  +$fragmentRefs: AvailabilityCalendarContainer_viewer$ref & ScheduleContainer_viewer$ref & LibraryContainer_viewer$ref,
  +$refType: InvoiceContainer_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "enabled",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "instructions",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "InvoiceContainer_viewer",
  "type": "User",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "payment_methods"
        ]
      }
    ]
  },
  "argumentDefinitions": [],
  "selections": [
    v0,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "first_name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "last_name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": "payment_methods",
      "name": "__InvoiceContainer_payment_methods_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "PaymentMethodConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "PaymentMethodEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "type": "CustomPaymentMethod",
                  "selections": [
                    v0,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "label",
                      "args": null,
                      "storageKey": null
                    },
                    v1,
                    v2
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "CheckPaymentMethod",
                  "selections": [
                    v0,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "address",
                      "args": null,
                      "storageKey": null
                    },
                    v1,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "pay_to",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "CashPaymentMethod",
                  "selections": [
                    v0,
                    v1,
                    v2
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "SquarePaymentMethod",
                  "selections": [
                    v0,
                    v1,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "application_id",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "location_id",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "AvailabilityCalendarContainer_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ScheduleContainer_viewer",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "primary_brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [
        v0
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "LibraryContainer_viewer",
      "args": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd90e8b9fb65a47e91c093f2af5ad6deb';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Invoice/__generated__/InvoiceContainer_viewer.graphql.js